import React from "react";
import SetupPanel from "@/components/SetupPanel";

export default function AdminCamping() {
  return <SetupPanel />;
}
